import {
  getSingalClassroomData,
  getTestsOfSubject,
} from "../../../../utils/classrooms";
import { setActiveTab } from "../../../../store/tabSlice";
import { setNavbarParams, setText } from "../../../../store/navbar";
import {
  getStudentEndPoints,
  MustIncludedSidebarItems,
} from "../../../../constants/sidebar";
import { setLinks, showLinks } from "../../../../store/sidebar";
import { extractModulesInMentionedOrder } from "../../../../utils/validations";

export const getClassroomDetails = async (
  classroomId,
  setClassroomName,
  setModules,
  setCreatedBy,
  setCourseId,
  setTabsList,
  setClassroomLoader,
  activeTab,
  dispatch
) => {
  try {
    setClassroomLoader(true);
    const response = await getSingalClassroomData(classroomId);
    if (response?.data?.classRoom) {
      if (response?.data?.classRoom?.name) {
        setClassroomName(response?.data?.classRoom?.name);
        setModules(response?.data?.classRoom?.modulesIncluded);
        setCreatedBy(response?.data?.classRoom?.createdBy);
        const subjects = response?.data?.classRoom?.course?.subjects
          .filter((subject) => !subject?.isHidden)
          .map((subject) => ({
            id: subject?._id,
            label: subject?.name,
          }));
        if (response?.data?.classRoom?.course?._id) {
          setCourseId(response?.data?.classRoom?.course?._id);
        }
        if (subjects?.length > 0) {
          const isCurrentTabValid = subjects.some(s => s.id === activeTab);
          if (!activeTab || !isCurrentTabValid) {
            dispatch(setActiveTab(subjects[0].id));
          }
        }
        setTabsList(subjects || []);
      }
    }
  } catch (error) {
    console.error("Error fetching classrooms:", error.message);
  }
  setClassroomLoader(false);
};

export const getTopicwiseTestListOfSubject = async (
  classroomId,
  courseId,
  activeTab,
  setSectionsList,
  setSelectedSections,
  setSelectedTopic,
  setSelectedMobileTopic,
  setTopicsList,
  setIsLoading
) => {
  try {
    setIsLoading(true);
    const response = await getTestsOfSubject(classroomId, courseId, activeTab);
    if (response.ok && response?.data?.sections) {
      const sectionsWithTests = response?.data?.sections.map((section) => {
        const filteredTopics = section?.topics
          ?.filter((topic) => !topic.isHidden)
          ?.filter((topic) => topic?.tests?.length > 0);
        return { ...section, topics: filteredTopics };
      });

      // Filter out sections that don't have any topics with tests
      const filteredSections = sectionsWithTests.filter(
        (section) => section?.topics?.length > 0
      );

      setSectionsList(filteredSections);
      const firstSection = filteredSections.find(
        (section) => section?.topics?.length > 0
      );
      if (firstSection) {
        setSelectedSections([firstSection?._id]);
        setSelectedTopic(firstSection?.topics[0]?._id);
        setSelectedMobileTopic([firstSection?.topics[0]?._id]);
      }

      let topicArray = [];
      filteredSections.forEach((section) => {
        topicArray = [...topicArray, ...section?.topics];
      });
      setTopicsList(topicArray);
    }
  } catch (error) {
    console.error("Error fetching classrooms:", error.message);
  }
  setIsLoading(false);
};

export const setupSidebar = (
  classroomId,
  classroomName,
  createdBy,
  dispatch,
  modules,
  roleOfTheUser,
  rolePermissions,
  userInformation
) => {
  const heading = "student-dashboard";
  dispatch(setText(heading));
  dispatch(setNavbarParams(`Topic-Wise Tests | ${classroomName}`));
  const defaultItems = [
    ...getStudentEndPoints(
      classroomId,
      roleOfTheUser,
      userInformation?._id === createdBy,
      rolePermissions
    ),
  ];
  const sidebarItems = defaultItems.filter(
    (item) =>
      modules.includes(item?.value) ||
      MustIncludedSidebarItems.includes(item?.value)
  );
  const indOfItem = sidebarItems?.findIndex(
    (item) => item.value === "Topic-wise Tests"
  );
  if (indOfItem !== -1) {
    sidebarItems[indOfItem].selected = true;
  }
  dispatch(setLinks(extractModulesInMentionedOrder(sidebarItems, modules)));
  dispatch(showLinks());
};
